// src/store/actionTypes.js

export const AUTH_REQUEST = "AUTH_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const LOGOUT = "LOGOUT";

export const USER_ADD = "USER_ADD";
export const USER_UPDATE = "USER_UPDATE";
export const USER_DELETE = "USER_DELETE";

export const SPORT_ADD = "SPORT_ADD";
export const SET_PAYOUT = "SET_PAYOUT";
export const SPORT_UPDATE = "SPORT_UPDATE";
export const SPORT_DELETE = "SPORT_DELETE";

export const PLAY_DEMO = "PLAY_DEMO";
